import $http from '@/api';

async function requestVideo(url) {
  try {
    const response = await $http.get(`/api/proxy?url=${encodeURI(url)}`);
    console.log('response:', response);
    return response;
  } catch (e) {
    console.log('error', e);
    return false;
  }
}

const videoProviders = {
  youtube: {
    handler(url) {
      const oembedUrl = `https://www.youtube.com/oembed?url=${url}`;
      return requestVideo(oembedUrl);
    },
    regex: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/,
  },
  vimeo: {
    handler(url) {
      const oembedUrl = `https://vimeo.com/api/oembed.json?url=${url}`;
      return requestVideo(oembedUrl);
    },
    regex: /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/,
  },
  dailymotion: {
    handler(url) {
      const oembedUrl = `https://www.dailymotion.com/services/oembed?url=${url}`;
      return requestVideo(oembedUrl);
    },
    regex: /(http|https)?:\/\/(www\.)?dailymotion.com\/video\/([-_0-9a-z]+)/,
  },
};

const videoProvidersAvailable = Object.keys(videoProviders);

const wizardCategoryTypes = ['microsite', 'section', 'blog'];

const defaultVideoProvider = 'youtube';

const videoEmbedStringRequired = true;

export default {
  videoProviders,
  videoProvidersAvailable,
  wizardCategoryTypes,
  defaultVideoProvider,
  videoEmbedStringRequired,
};
